import { NaicsCodeEntity } from '../Models/Api/strongbox.financialportal';

import { FetchMethod, fetchWrapper } from '../Utils/FetchWrapper';

import { LogMessage, LogException, SeverityLevel } from '../Utils/Logging';

export async function GetBasicNaicsCodes(): Promise<NaicsCodeEntity[]> {
    LogMessage(
        `GetBasicNaicsCodes`,
        SeverityLevel.Information
    );
    const url = `/api/Industries/basicNaicsCodes`;

    try {
        // noCache: false (the 5th arg) so this request omits the default cache-control/pragma no-cache
        // headers and the browser can honour the server's `private, max-age` + ETag caching for this
        // static reference list. Every other call keeps the wrapper's no-cache default.
        const res = await fetchWrapper(url,
            {
                method: FetchMethod.Get,
            },
            true,
            true,
            false
        );
        if (!res.ok) {
            LogException(
                `GetBasicNaicsCodes failed`,
                new Error(res.statusText)
            );

            console.error(`Failure retrieving basic Naics codes status=${res.status}`);
            return [];
        }
        return await res.json();
    } catch (fetchException) {
        LogException(
            `GetBasicNaicsCodes failed`,
            fetchException
        );

        console.error(`Catastrophic failure retrieving basic Naics codes`);
        console.error(fetchException);

        return [];
    }
}

export async function GetNaicsCodes(
    query: string
): Promise<NaicsCodeEntity[]> {
    LogMessage(
        `GetNaicsCode`,
        SeverityLevel.Information,
        {
            query
        }
    );
    const url = `/api/Industries/NaicsCodes?query=${query}`;

    try {
        const res = await fetchWrapper(url,
            {
                method: FetchMethod.Get,
            },
            true,
            true
        );
        if (!res.ok) {
            LogException(
                `GetNaicsCode failed`,
                new Error(res.statusText),
                {
                    query
                }
            );

            console.error(`Failure retrieving Naics codes for ${query} status=${res.status}`);
            return [];
        }
        return await res.json();
    } catch (fetchException) {
        LogException(
            `GetNaicsCode failed`,
            fetchException,
            {
                query
            }
        );

        console.error(`Catastrophic failure retrieving Naics codes for ${query}`);
        console.error(fetchException);

        return [];
    }
}
